import { render, staticRenderFns } from "./StateTargetting.vue?vue&type=template&id=585a70d4&"
import script from "./StateTargetting.vue?vue&type=script&lang=ts&"
export * from "./StateTargetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports